import { createSlice } from '@reduxjs/toolkit';
import { setTrendsLineData, getDataLine } from './sliceUtil';
export const entityTrendLine = createSlice({
  name: 'entityTrendLine',
  initialState: {
    dataLine: getDataLine(),
    entityTrendData: []
  },
  reducers: {
    pushEntityTrendData: (state, action) => {
      state.entityTrendData = action.payload;
      setTrendsLineData(state, state.entityTrendData);
    },
    setEntityTrendData: (state, action) => {
      state.trend = action.payload;
      setTrendsLineData(state, state.entityTrendData);
    }
  }
});
export const {
  pushEntityTrendData,
  setEntityTrendData
} = entityTrendLine.actions;
export default entityTrendLine.reducer;